<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button icon-only (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Sales</ion-title>
    </ion-toolbar>
</ion-header>
<ion-content>
  <smr-sale-details [sale]="sale"></smr-sale-details>
</ion-content>
